import { render } from "./TeilnehmerCopy.vue?vue&type=template&id=72d32a3d"
import script from "./TeilnehmerCopy.vue?vue&type=script&setup=true&lang=js"
export * from "./TeilnehmerCopy.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/TeilnehmerCopy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72d32a3d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72d32a3d', __exports__)) {
    api.reload('72d32a3d', __exports__)
  }
  
  module.hot.accept("./TeilnehmerCopy.vue?vue&type=template&id=72d32a3d", () => {
    api.rerender('72d32a3d', render)
  })

}


export default __exports__